$.fn.customScroll = function() {

    var jqAllAffectedContainers = this;
    var ps = null;

    jqAllAffectedContainers.each(function() {
        ps = new PerfectScrollbar(this, {
            maxScrollbarLength: 50,
        });
    });

    return ps;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.custom-scroll.scroll-standalone').customScroll();
});
